import Image, { ImageProps } from "next/image";

const LocalImage = ({ src, ...props }: ImageProps) => (
  // eslint-disable-next-line react/forbid-elements, jsx-a11y/alt-text
  <Image src={src} unoptimized {...props} />
);

export default LocalImage;
